import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { useValidation } from "../../context/ValidationContext";

export default function LoginPage() {

  const { otp } = useParams();
  const navigate = useNavigate();

  const allowedOTP = "fsf-1122";

  useEffect(() => {
    if (otp !== allowedOTP) {
      navigate("/");
    }
  }, [otp, navigate]);

  const { login } = useAuth();
  const { validateEmail } = useValidation();
  const { t } = useContext(TranslatorContext);

  const validatePassword = (password) => {
    return password.length >= 8;
  };

  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (submitted) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    let newErrors = { email: "", password: "" };
    let hasError = false;

    if (!values.email.trim()) {
      newErrors.email = "Email is required";
      hasError = true;
    } else if (!validateEmail(values.email)) {
      newErrors.email = "Invalid email address";
      hasError = true;
    }

    if (!values.password.trim()) {
      newErrors.password = "Password is required";
      hasError = true;
    } else if (!validatePassword(values.password)) {
      newErrors.password = "Password must be at least 8 characters";
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    try {
      const res = await axios.post(
        process.env.REACT_APP_API_URL + "/login",
        {
          email: values.email.trim(),
          password: values.password.trim(),
        }
      );

      if (res && res.data.success) {
        localStorage.setItem("authToken", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        login(res.data);

        window.location.href = "/";
      } else {
        setErrors({
          ...newErrors,
          password: "Invalid email or password",
        });
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrors({
        ...newErrors,
        password: "Invalid email or password",
      });
    }
  };

  return (
    <div className="mc-auth">
      <img src="/images/pattern.webp" alt="pattern" className="mc-auth-pattern" />

      <div className="mc-auth-group">
        <LogoComponent
          src="/images/fsf.png"
          alt="logo"
          href="/"
          className="mc-auth-logo"
        />

        <h4 className="mc-auth-title">Login to Families Set Free</h4>

        <form onSubmit={handleLogin} className="mc-auth-form">

          <IconFieldComponent
            icon="email"
            type="email"
            name="email"
            onChange={handleChange}
            classes="w-100 h-sm"
            placeholder="Enter your email"
            value={values.email}
          />

          {errors.email && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors.email}
            </span>
          )}

          <IconFieldComponent
            icon="lock"
            type="password"
            name="password"
            onChange={handleChange}
            classes="w-100 h-sm"
            placeholder="Enter your password"
            passwordVisible={true}
            value={values.password}
          />

          {errors.password && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors.password}
            </span>
          )}

          <ButtonComponent className="mc-auth-btn h-sm" type="submit">
            {t("sign_in")}
          </ButtonComponent>

          <AnchorComponent className="mc-auth-forgot" to="/forgot-password">
            {t("forgot_password")}
          </AnchorComponent>

        </form>
      </div>
    </div>
  );
}